import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";

export default class ExternalClickListener extends Component {
  wrapperRef = React.createRef();

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (!this.wrapperRef) return;

    // We want to call onExternalClick on clicks outside of the wrapper
    // and clicks on the wrapper itself.
    // We call onExternalClick on clicks on the wrapper itself to prevent the following
    // scenario where the wrapper contains children of uneven width.
    /*
    +WRAPPER-------------------+
    |CHILD 1------------------+|
    ||                        ||
    ||                        ||
    ||                        ||
    ||                        ||
    |+------------------------+|
    |CHILD 2-+  clicks in this |
    ||       |  empty area     |
    ||       |  don't trigger  |
    ||       |  the handler    |
    |+-------+                 |
    +--------------------------+
    */
    // This is strange behaviour as the area clicked in the scenario above is transparent
    // and a user will expect it to close the menu.
    // If we trigger the onExternalClick handler on clicks on the wrapper itself then
    // this scenario is prevented.
    const { onExternalClick } = this.props;
    if (
      !this.wrapperRef.current.contains(event.target) ||
      event.target === this.wrapperRef.current
    ) {
      onExternalClick();
    }
  };

  render() {
    const { children } = this.props;
    return (
      <div ref={this.wrapperRef} className={styles.wrapper}>
        {children}
      </div>
    );
  }
}

ExternalClickListener.propTypes = {
  onExternalClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};
